/* eslint-env browser */

'use strict';

const {
  loadDynamicCSS,
  loadDynamicJS,
  setShellEventOrRun,
} = require('@grpn/shell-page');

require('./index.styl');

require('../base/index.js');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

setShellEventOrRun(() => {
  if (window.shellLayout && window.payload.loadGliveBooker) {
    loadDynamicCSS();
    loadDynamicJS();
  }

  jsInitializer
    .addJsFiles(critModules, nonCritModules, pageReadyModules)
    .initialize();
});
